import { useTranslation } from 'react-i18next';
import { RouteComponentProps } from 'react-router';
import { DASHBOARD, KYC_AGREEMENT } from '../../routes/routes';
import { H2, H3, P1, P2 } from '../../styles/FontStyles';
import { Button } from '../../styles/GlobalComponents';
import { colors } from '../../styles/GlobalStyles';
import { Desktop, Mobile } from './KycStyled';
import { AnimatedDashboard } from '../../components';

const KycStart = ({ history }: RouteComponentProps) => {
  const { t } = useTranslation('kyc');
  return (
    <AnimatedDashboard key={'kyc-start'}>
      <Desktop>
        <H2 mb='24'>{t('start.title')}</H2>

        <P1
          mb='40'
          maxWidth='600px'
          maxWidthSM='1000px'
          color={colors.neutral500}>
          {t('start.description')}
        </P1>
      </Desktop>

      <Mobile>
        <H3 mb='8' center>
          {t('start.title')}
        </H3>

        <P2 mb='32' center color={colors.neutral500}>
          {t('start.description')}
        </P2>
      </Mobile>

      <Desktop>
        <Button
          opacity={'true'}
          onClick={() => history.push(KYC_AGREEMENT)}
          mr='20'
          h='44px'
          maxWidth='200px'>
          {t('start.continue')}
        </Button>
        <Button
          negative
          h='44px'
          maxWidth='200px'
          opacity={'true'}
          onClick={() => history.push(DASHBOARD)}>
          {t('start.verify_later')}
        </Button>

        {/* <AuthButton>asdasdasd</AuthButton> */}
      </Desktop>
      <Mobile>
        <Button mb='12' onClick={() => history.push(KYC_AGREEMENT)}>
          {t('start.continue')}
        </Button>
        <Button negative onClick={() => history.push(DASHBOARD)}>
          {t('start.verify_later')}
        </Button>
      </Mobile>
    </AnimatedDashboard>
  );
};

export default KycStart;
